export const GAME_CONFIG = {
  REELS_COUNT: 5,
  ROWS_COUNT: 3,
  SYMBOL_SIZE: 110,
  SYMBOL_SPACING: 6,
  REEL_WIDTH: 110,
  REEL_SPACING: 12,
  
  SPIN_DURATION: 1200,
  REEL_STOP_DELAY: 150,
  MIN_SPIN_SPEED: 10,
  MAX_SPIN_SPEED: 25,
  
  PAYLINES: [
    [[0,0], [1,0], [2,0], [3,0], [4,0]],
    [[0,1], [1,1], [2,1], [3,1], [4,1]],
    [[0,2], [1,2], [2,2], [3,2], [4,2]],
    [[0,0], [1,1], [2,2], [3,1], [4,0]],
    [[0,2], [1,1], [2,0], [3,1], [4,2]],
    [[0,1], [1,0], [2,0], [3,0], [4,1]],
    [[0,1], [1,2], [2,2], [3,2], [4,1]],
    [[0,0], [1,0], [2,1], [3,2], [4,2]],
    [[0,2], [1,2], [2,1], [3,0], [4,0]],
    [[0,1], [1,1], [2,0], [3,1], [4,1]],
    [[0,1], [1,1], [2,2], [3,1], [4,1]],
    [[0,0], [1,1], [2,1], [3,1], [4,0]],
    [[0,2], [1,1], [2,1], [3,1], [4,2]],
    [[0,0], [1,2], [2,0], [3,2], [4,0]],
    [[0,2], [1,0], [2,2], [3,0], [4,2]],
    [[0,1], [1,2], [2,2], [3,1], [4,0]],
    [[0,1], [1,0], [2,0], [3,1], [4,2]],
    [[0,2], [1,1], [2,1], [3,2], [4,0]],
    [[0,0], [1,1], [2,1], [3,0], [4,1]],
    [[0,2], [1,1], [2,1], [3,2], [4,1]]
  ],

  SYMBOLS: {
    HIGH_VALUE: [
      { id: 'symbol_1', name: 'Symbol_1', multipliers: [0, 0, 100, 200, 500] },
      { id: 'symbol_2', name: 'Symbol_2', multipliers: [0, 0, 80, 150, 400] },
      { id: 'symbol_3', name: 'Symbol_3', multipliers: [0, 0, 60, 120, 300] }
    ],
    MEDIUM_VALUE: [
      { id: 'symbol_4', name: 'Symbol_4', multipliers: [0, 0, 40, 80, 200] },
      { id: 'symbol_5', name: 'Symbol_5', multipliers: [0, 0, 35, 70, 180] },
      { id: 'symbol_6', name: 'Symbol_6', multipliers: [0, 0, 30, 60, 150] },
      { id: 'symbol_7', name: 'Symbol_7', multipliers: [0, 0, 25, 50, 120] },
      { id: 'symbol_8', name: 'Symbol_8', multipliers: [0, 0, 25, 50, 120] }
    ],
    LOW_VALUE: [],
    SPECIAL: [
      { id: 'wild', name: 'Wild', type: 'wild', multipliers: [0, 0, 50, 100, 250] },
      { id: 'scatter', name: 'Scatter', type: 'scatter', multipliers: [0, 0, 5, 20, 100] }
    ]
  },

  INITIAL_BALANCE: 10000,
  MIN_BET: 10,
  MAX_BET: 1000,
  BET_LEVELS: [10, 20, 50, 100, 200, 500, 1000],
  
  FREE_SPINS_TRIGGER: 3,
  FREE_SPINS_COUNT: 10,
  FREE_SPINS_MULTIPLIER: 2,

  WILD_SYMBOL_ID: 'wild',
  SCATTER_SYMBOL_ID: 'scatter'
};

export type SymbolData = {
  id: string;
  name: string;
  multipliers: number[];
  type?: 'wild' | 'scatter';
};

export function getAllSymbols(): SymbolData[] {
  return [
    ...GAME_CONFIG.SYMBOLS.HIGH_VALUE,
    ...GAME_CONFIG.SYMBOLS.MEDIUM_VALUE,
    ...GAME_CONFIG.SYMBOLS.LOW_VALUE
  ];
}